import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  Icon,
  Row,
  Col,
  HeadingText,
  BodyText,
  Link,
} from '@paypalcorp/pp-react'
import { number, object, array, element } from 'prop-types'

// it will construct htmlList with title
const PrivacyHubList = ({ listItems, title, subHeading,children }) => {
  return (
    <div>
      {subHeading && (
        <HeadingText
          size={subHeading.size}
          className={subHeading.class}
          id={subHeading.id}
        >
          <Message id={subHeading.messageId} />
        </HeadingText>
      )}
      {(listItems?.length === 1 && !title) ? (
        <TextContent
          description={listItems[0].description}
          descriptionLink={listItems[0].descriptionLink}
        />
      ) : (
        <>
          {title && <ListTitle {...title} />}
          <ul className={`privacy_hub_list`}>
            {listItems.map((item, index) => (
              <ListItem
                key={index}
                description={item?.description}
                descriptionLink={item?.descriptionLink}
                index={index}
              />
            ))}
          </ul>
          {
            children
          }
        </>
      )}
    </div>
  )
}

const ListTitle = (props) => (
  <BodyText className={props.class} id={props.id}>
    <Message id={props.messageId} />
  </BodyText>
)

const TextContent = ({ description, descriptionLink }) => (
  <BodyText className={`${description?.class}` } id={description?.id}>
    <Message
      id={description.messageId}
      link={(innerMessage) => (
        <Link
          name={descriptionLink?.name}
          href={descriptionLink?.href}
          className={descriptionLink?.class}
          id={descriptionLink?.id}
          size={descriptionLink.size}
        >
          {innerMessage}
        </Link>
      )}
    />
  </BodyText>
)

const ListItem = ({ description, descriptionLink }) => (
  <li>
    <TextContent description={description} descriptionLink={descriptionLink} />
  </li>
)

/*
eg:Accepted Object is {
 heading:{
    messageId:string,//messageId
    id:string,//html id
    class:string,
    size:number }
 descriptionList:[
  {description:{
    messageId:string,
    id:string,
    class:string
 },  - Driven from locals
  descriptionLink:{
    name:string,
    url:string,
    id:string
    class:string
  },
  listTitle:string,
  subtitle:string
}]
  icon:{

  }
}
*/
const Section = ({
  heading,
  descriptionList,
  asset,
  cols,
  order,
  title = null,
  subHeading = null,
  children,
  Content
})=>(
  <>
    <Row className="row" noGutters>
        <PrivacyHubImage {...asset}/>
        <PrivacyHubText {...{heading,descriptionList,title,order,subHeading,cols,children,Content}}/>
    </Row>
  </>
)
const PrivacyHubText =({
  heading,
  descriptionList,
  title,
  subHeading,
  cols,
  order,
  children,
  Content
})=>(
      <Col
        className={`privacy-hub-section-content`}
        xs={{ order: 2,span: 12 }}
        md={{ order,span: cols }}
      >
        {heading?.messageId && (
          <HeadingText
            size={heading.size}
            className={heading?.class} // customClass
            id={heading.id}
          >
            <Message id={heading.messageId} />
          </HeadingText>
        )}
         <PrivacyHubList
            listItems={descriptionList}
            title={title}
            subHeading={subHeading}
          >
            {
               Content
            }
          </PrivacyHubList>
        {children}
      </Col>)

const PrivacyHubImage = ({
icon_svg_link,
component_icon,
imgSrc,
imgClass,
alt,
name,
size,
color,
svgIconClass,
order,
cols,
}) => (
  <>
    {(icon_svg_link || component_icon) && (
      <Col
        className={`privacy-icon-section`}
        xs={{ order: 1, span: 12 }}
        md={{
          order,
          span: cols,
        }}
      >
        {icon_svg_link && (
          <div className={imgClass}>
            <img src={imgSrc} alt={alt} className={`icon`} />
          </div>
        )}
        {component_icon && (
          <div className={svgIconClass}>
            <Icon name={name} size={size} color={color} />
          </div>
        )}
      </Col>
    )}
  </>
)

Section.propTypes = {
  heading: object,
  descriptionList: array,
  title: object,
  subHeading: object,
  asset: object,
  cols: number,
  order: number,
  children: element,
}
export default Section
